import React from 'react';
import { Counter } from 'graphql-common';
import { FormRefType } from '@lib/components/ReactHookForm/types';
import { UseBulkSelectResult } from '@lib/hooks/useTableItemsBulkSelect';
import AssetCounters from 'components/AssetCounters/AssetCounters';
import { SubmitAction } from '@lib/enums/form';
import { AssetViewMode } from './enums';
import useCounterActions from './utils/useCounterActions';
import { UseSearchListQueriesResult } from './utils/useSearchListQueries';
import { UseModalManagementResult } from './utils/useModalManagement';
import { UseActionsResult } from './utils/useActions';

type Props = {
  useBulkSelectResult?: UseBulkSelectResult<Counter>;
  useActionsResult: UseActionsResult;
  useModalManagementResult: UseModalManagementResult;
  useSearchListQueriesResult: UseSearchListQueriesResult;
  submitNewItemRef: React.RefObject<SubmitAction | undefined>;
  formRef: FormRefType;
  viewMode: AssetViewMode;
  isViewOnly: boolean;
  isCounterViewOnly: boolean;
};

export default function AssetCountersContainer(props: Props) {
  const {
    useBulkSelectResult,
    useActionsResult,
    useModalManagementResult,
    useSearchListQueriesResult,
    submitNewItemRef,
    formRef,
    viewMode,
    isViewOnly,
    isCounterViewOnly,
  } = props;

  const useCounterActionsResult = useCounterActions({
    formRef,
    useActionsResult,
    submitNewItemRef,
    useModalManagementResult,
    useBulkSelectResult,
    viewMode,
  });

  return (
    <AssetCounters
      formRef={formRef}
      submitNewItemRef={submitNewItemRef}
      useActionsResult={useActionsResult}
      useBulkSelectResult={useBulkSelectResult}
      useCounterActionsResult={useCounterActionsResult}
      useModalManagementResult={useModalManagementResult}
      useSearchListQueriesResult={useSearchListQueriesResult}
      isViewOnly={isViewOnly}
      isCounterViewOnly={isCounterViewOnly}
    />
  );
}
